module.exports = __webpack_public_path__ + "static/media/alexis-bledel-win.92849824.jpeg";